module.exports = __webpack_public_path__ + "a16dc3970218540e346d5b4468ba517b.png";